import './index.scss'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import Swiper from 'swiper/js/swiper.min.js'


$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  $('.section1 .bg').css('transform','translateY('+ scroH / 5 +'px)')
});
$(document).ready(function(){
  let tabL = $('.section5 .sec5-tab div').length
  if($(window).width() < 768){
    if(tabL >= 5){
      $('.section5 .sec5-tab').css('justify-content','flex-start')
    }else{
      $('.section5 .sec5-tab').css('justify-content','center')
    }
  }
})

var swiper5 = new Swiper(".section5 .sec5-swiper .mySwiper", {
  allowTouchMove: false,
  autoHeight: true, //高度随内容变化
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on: {
    init: function(swiper){
      $('.section5 .sec5-tab div').eq(this.activeIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section5 .sec5-tab div').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
    resize: function(){
      this.update();
    }, 
  },
});
$('.section5 .sec5-tab div').on('click',function(){
  let index = $(this).index()
  swiper5.slideTo(index)
})

var swiper6 = new Swiper(".section6 .sec6-swiper .mySwiper", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 10,
  pagination: {
    el: ".section6 .sec6-swiper .swiper-pagination",
    clickable: true
  },
  breakpoints: {
    1025: {  //当屏幕宽度小于等于768
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 40,
    },
    640: {  //当屏幕宽度小于等于320
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20,
    }
  }
});


var swiper7text = new Swiper(".section7 .text-swiper .mySwiper", {
  // allowTouchMove: false,
  speed: 600,
  slidesPerView: 1,
  spaceBetween: 15,
  autoHeight: true,
  // breakpoints: {
  //   768: {  //当屏幕宽度小于等于320
  //     slidesPerView: 1,
  //     spaceBetween: 15,
  //   }
  // },
  on: {
    slideChangeTransitionStart: function(){
      swiper7img.slideTo(this.activeIndex)
    },
  },
});
var swiper7img = new Swiper(".section7 .img-swiper .mySwiper", {
  speed: 500,
  slidesPerView: 1,
  spaceBetween: 15,
  pagination: {
    el: ".section7 .swiper-pagination",
    clickable: true
  },
  // breakpoints: {
  //   768: {  //当屏幕宽度小于等于320
  //     slidesPerView: 1,
  //     spaceBetween: 15,
  //   }
  // },
  on: {
    slideChangeTransitionStart: function(){
      swiper7text.slideTo(this.activeIndex)
    },
  },
});

$('.section1 .link .md').on('click',function(){
  let scrollT = $('.section5').offset().top
  if($(window).width() <= 1024 && $(window).width() > 768){
    scrollT = $('.section5').offset().top - 60
  }
  if($(window).width() <= 768){
    scrollT = $('.section5').offset().top - 55
  }
  $(document).scrollTop(scrollT)
})
$('.section1 .mob-link .md').on('click',function(){
  let scrollT = $('.section5').offset().top - 60
  $(document).scrollTop(scrollT)
})